import {Component, OnInit} from '@angular/core';
import * as moment from 'moment';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {AsistenciaService} from '../_services/asistencia.service';
import {UntypedFormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

const MOCKDATA = [
  {alumno: {id: 1, codigo: 1, apellidosNombres: 'Est1'}, faltaTarea: {detalle: 'detalle de la tarea'}, curso: {nombre: 'CursoNombre1'}},
  {alumno: {id: 2, codigo: 2, apellidosNombres: 'Est2'}, faltaTarea: {detalle: 'detalle de la tarea'}, curso: {nombre: 'CursoNombre1'}},
  {alumno: {id: 3, codigo: 3, apellidosNombres: 'Est3'}, faltaTarea: {detalle: 'detalle de la tarea'}, curso: {nombre: 'CursoNombre1'}},
  {alumno: {id: 4, codigo: 4, apellidosNombres: 'Est4'}, faltaTarea: {detalle: 'detalle de la tarea'}, curso: {nombre: 'CursoNombre2'}},
  {alumno: {id: 5, codigo: 5, apellidosNombres: 'Est5'}, faltaTarea: {detalle: 'detalle de la tarea'}, curso: {nombre: 'CursoNombre3'}},
  {alumno: {id: 6, codigo: 6, apellidosNombres: 'Est6'}, faltaTarea: {detalle: 'detalle de la tarea'}, curso: {nombre: 'CursoNombre3'}},
  {alumno: {id: 7, codigo: 7, apellidosNombres: 'Est7'}, faltaTarea: {detalle: 'detalle de la tarea'}, curso: {nombre: 'CursoNombre4'}},
  {alumno: {id: 8, codigo: 8, apellidosNombres: 'Est8'}, faltaTarea: {detalle: 'detalle de la tarea'}, curso: {nombre: 'CursoNombre4'}},
];

@Component({
  selector: 'reporte-transporte',
  standalone: false,
  templateUrl: 'reporte-transporte.component.html'
})

export class ReporteTransporteComponent implements OnInit {

  columns = ['curso', 'codigo', 'alumno', 'novedades'];
  studentsList = MOCKDATA;
  filterInputCtrl = new UntypedFormControl();
  filteredStudentList: Observable<any[]>;

  periodos;
  fechaInicioCalendar;
  fechaFinCalendar;
  fechaSeleccionada;
  fechaCalendar;

  fechaGenerado;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private title: Title,
              private asistenciaService: AsistenciaService) {
    title.setTitle('Reporte transporte - MiGLM');
  }

  ngOnInit() {
    this.periodos = this.route.parent.snapshot.data['periodos'];
    this.fechaInicioCalendar = moment(this.periodos[0].fechaInicia.substring(0, 10), 'YYYY-MM-DD');
    this.fechaFinCalendar = moment(this.periodos[0].fechaFin.substring(0, 10), 'YYYY-MM-DD');

    this.fechaGenerado = moment();

    this.fechaSeleccionada = this.route.snapshot.paramMap.get('fecha');
    if (this.fechaSeleccionada == null) {
      this.fechaSeleccionada = moment().format('YYYY-MM-DD');
    }

    this.fechaCalendar = {mDate: moment(this.fechaSeleccionada), selected: true};

    this.filteredStudentList = this.filterInputCtrl.valueChanges.pipe(
      startWith(null),
      map((student) => student ? this._filterStudent(student) : this.studentsList.slice())
    );

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  changeDate(date) {
    this.router.navigate(['/', 'asistencia', 'reporte', 'transporte', 'fecha', date.mDate.format('YYYY-MM-DD')]);
  }

  private _filterStudent(value: string) {
    const filterValue = value && typeof value === 'string' ? value.toLowerCase() : '';
    return this.studentsList.filter(student => student.alumno.apellidosNombres.toLowerCase().indexOf(filterValue) > -1);
  }

}
